// Theme: frost-byte
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'frost-byte',
  name: 'FROST BYTE',
  tagline: 'FROST BYTE',
  description: 'Frost byte. Interface fria e precisa como gelo digital.',
  category: 'neon-cyber',
  tier: 'common',
  basePrice: 1575,
  swatches: ['#2F3A4A', '#3A4A5A', '#93C5D4', '#F6F8FA'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '8px',
      '--shadow-card': '0 8px 20px rgba(0, 0, 0, 0.20)',
      '--shadow-card-active': '0 10px 24px color-mix(in srgb, var(--primary) 30%, transparent)'
    },
    shellClasses: 'font-mono theme-frost-byte'
  },
  colorVars: {
    '--accent': '#93C5D4',
    '--accent-foreground': '#2F3A4A',
    '--background': '#2F3A4A',
    '--border': '#6A8A9A',
    '--card': '#3A4A5A',
    '--card-border-active': 'rgba(147, 197, 212, 0.28)',
    '--card-completed': '#334251',
    '--card-foreground': '#F6F8FA',
    '--card-glow': 'rgba(147, 197, 212, 0.04)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#2F3A4A',
    '--foreground': '#F6F8FA',
    '--hold-fill': '#93C5D4',
    '--input': '#6A8A9A',
    '--modal-bg': '#2F3A4A',
    '--modal-border': '#6A8A9A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 8px 20px rgba(0, 0, 0, 0.20)',
    '--muted': '#6A8A9A',
    '--muted-foreground': '#F6F8FA',
    '--nav-active': '#93C5D4',
    '--nav-bg': '#3A4A5A',
    '--popover': '#3A4A5A',
    '--popover-foreground': '#F6F8FA',
    '--primary': '#93C5D4',
    '--primary-foreground': '#2F3A4A',
    '--ring': '#93C5D4',
    '--secondary': '#6A8A9A',
    '--secondary-foreground': '#F6F8FA',
    '--streak': '#93C5D4',
    '--success': '#22c55e',
    '--success-foreground': '#2F3A4A',
    '--xp': '#93C5D4',
    '--xp-bg': '#3A4A5A'
  },
  resolvedVars: {
    '--accent': '#93C5D4',
    '--accent-foreground': '#2F3A4A',
    '--accent-foreground-hsl': '216 22% 24%',
    '--accent-foreground-oklch': 'from #2F3A4A l c h',
    '--accent-hsl': '194 43% 70%',
    '--accent-oklch': 'from #93C5D4 l c h',
    '--background': '#2F3A4A',
    '--background-hsl': '216 22% 24%',
    '--background-oklch': 'from #2F3A4A l c h',
    '--border': '#6A8A9A',
    '--border-hsl': '200 19% 51%',
    '--border-oklch': 'from #6A8A9A l c h',
    '--border-w': '1px',
    '--card': '#3A4A5A',
    '--card-border-active': 'rgba(147, 197, 212, 0.28)',
    '--card-completed': '#334251',
    '--card-completed-hsl': '210 23% 26%',
    '--card-completed-oklch': 'from #334251 l c h',
    '--card-foreground': '#F6F8FA',
    '--card-foreground-hsl': '210 29% 97%',
    '--card-foreground-oklch': 'from #F6F8FA l c h',
    '--card-glow': 'rgba(147, 197, 212, 0.04)',
    '--card-hsl': '210 22% 29%',
    '--card-oklch': 'from #3A4A5A l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#2F3A4A',
    '--destructive-foreground-hsl': '216 22% 24%',
    '--destructive-foreground-oklch': 'from #2F3A4A l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#F6F8FA',
    '--foreground-hsl': '210 29% 97%',
    '--foreground-oklch': 'from #F6F8FA l c h',
    '--hold-fill': '#93C5D4',
    '--hold-fill-hsl': '194 43% 70%',
    '--hold-fill-oklch': 'from #93C5D4 l c h',
    '--input': '#6A8A9A',
    '--input-hsl': '200 19% 51%',
    '--input-oklch': 'from #6A8A9A l c h',
    '--modal-bg': '#2F3A4A',
    '--modal-bg-hsl': '216 22% 24%',
    '--modal-bg-oklch': 'from #2F3A4A l c h',
    '--modal-border': '#6A8A9A',
    '--modal-border-hsl': '200 19% 51%',
    '--modal-border-oklch': 'from #6A8A9A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 8px 20px rgba(0, 0, 0, 0.20)',
    '--muted': '#6A8A9A',
    '--muted-foreground': '#F6F8FA',
    '--muted-foreground-hsl': '210 29% 97%',
    '--muted-foreground-oklch': 'from #F6F8FA l c h',
    '--muted-hsl': '200 19% 51%',
    '--muted-oklch': 'from #6A8A9A l c h',
    '--nav-active': '#93C5D4',
    '--nav-active-hsl': '194 43% 70%',
    '--nav-active-oklch': 'from #93C5D4 l c h',
    '--nav-bg': '#3A4A5A',
    '--nav-bg-hsl': '210 22% 29%',
    '--nav-bg-oklch': 'from #3A4A5A l c h',
    '--popover': '#3A4A5A',
    '--popover-foreground': '#F6F8FA',
    '--popover-foreground-hsl': '210 29% 97%',
    '--popover-foreground-oklch': 'from #F6F8FA l c h',
    '--popover-hsl': '210 22% 29%',
    '--popover-oklch': 'from #3A4A5A l c h',
    '--primary': '#93C5D4',
    '--primary-foreground': '#2F3A4A',
    '--primary-foreground-hsl': '216 22% 24%',
    '--primary-foreground-oklch': 'from #2F3A4A l c h',
    '--primary-hsl': '194 43% 70%',
    '--primary-oklch': 'from #93C5D4 l c h',
    '--radius': '8px',
    '--ring': '#93C5D4',
    '--ring-hsl': '194 43% 70%',
    '--ring-oklch': 'from #93C5D4 l c h',
    '--secondary': '#6A8A9A',
    '--secondary-foreground': '#F6F8FA',
    '--secondary-foreground-hsl': '210 29% 97%',
    '--secondary-foreground-oklch': 'from #F6F8FA l c h',
    '--secondary-hsl': '200 19% 51%',
    '--secondary-oklch': 'from #6A8A9A l c h',
    '--shadow-card': '0 8px 20px rgba(0, 0, 0, 0.20)',
    '--shadow-card-active': '0 10px 24px color-mix(in srgb, var(--primary) 30%, transparent)',
    '--streak': '#93C5D4',
    '--streak-hsl': '194 43% 70%',
    '--streak-oklch': 'from #93C5D4 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#2F3A4A',
    '--success-foreground-hsl': '216 22% 24%',
    '--success-foreground-oklch': 'from #2F3A4A l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(194 43% 70% / 0.15)',
    '--xp': '#93C5D4',
    '--xp-bg': '#3A4A5A',
    '--xp-bg-hsl': '210 22% 29%',
    '--xp-bg-oklch': 'from #3A4A5A l c h',
    '--xp-hsl': '194 43% 70%',
    '--xp-oklch': 'from #93C5D4 l c h'
  }
}
